import React from "react";
import { useTranslation } from "react-i18next";
import { BlockTry } from "../../blocks/common-blocktry";
import { CommonConsult } from "../../blocks/common-consult";
import { PrivateCloudAdvantage } from "../../blocks/private-cloud-advantage";
import { PrivateCloudBanner } from "../../blocks/private-cloud-banner";
import { PrivateCloudQuestion } from "../../blocks/private-cloud-question";
import { PrivateCloudResource } from "../../blocks/private-cloud-resource";
import { Button } from "../../components/Button";
import { Footer } from "../../components/FooterV2";

import { Header } from "../../components/Header";

import "./styles.less";

export const PrivateCloudPage = () => {
  const { t } = useTranslation();
  return (
    <div className="private-cloud-page">
      <Header mode={"dark"} />
      <PrivateCloudBanner />
      <PrivateCloudResource />
      <PrivateCloudAdvantage />
      <PrivateCloudQuestion />
      <BlockTry
        aside={
          <CommonConsult
            aside={
              <Button
                style={{
                  margin: 0,
                  background: "none",
                  color: "#215ae5",
                  border: "1px solid #215ae5",
                  marginRight: "20px",
                }}
              >
                {t("common.button.consult")}
              </Button>
            }
          />
        }
      />
      <Footer />
    </div>
  );
};
